export const mediumPvE = ({ username }) => {
  const description =
    "Description:\nA medium sized PvE mission with 28 Slots and a UH-80 Ghosthawk.";
  return {
    description,
    schema: {
      event: {
        event_date: `${new Date().getFullYear()}-01-01T21:00:00Z`,
        event_title: "Default Medium PvE",
        event_desc: "Add your google doc briefing link here",
        event_owner: username,
        event_reserves: [],
        event_repo: "MAIN",
      },
      sides: [
        {
          side: "BLU",
          groups: [
            {
              group_data: {
                group_name: "COMMAND",
                group_orbat_icon: "nato_inf",
                group_gear: "",
                group_callsign: "ROBIN",
                group_background: "DEFAULT",
              },
              slots: [
                {
                  slot_name: "CO",
                  slot_player: {
                    player_id: "",
                    player_name: "",
                  },
                  slot_shortcode: "CO",
                  slot_gear: "SPAR-16 CARBINE",
                  slot_restricted: true,
                  slot_locked: false,
                  slot_icon_code: "OFFICER",
                  slot_dlc: [],
                  slot_raffle: false,
                  raffle_winner: {
                    player_id: "",
                    player_name: "",
                  },
                  raffle_entrants: [],
                },
                {
                  slot_name: "Ptn. Medic",
                  slot_player: {
                    player_id: "",
                    player_name: "",
                  },
                  slot_shortcode: "MED",
                  slot_gear: "SPAR-16 CARBINE",
                  slot_restricted: true,
                  slot_locked: false,
                  slot_icon_code: "MED",
                  slot_dlc: [],
                  slot_raffle: false,
                  raffle_winner: {
                    player_id: "",
                    player_name: "",
                  },
                  raffle_entrants: [],
                },
              ],
              child: [
                {
                  group_data: {
                    group_name: "ALPHA",
                    group_orbat_icon: "nato_inf",
                    group_gear: "HMMWV",
                    group_callsign: "FALCON ACTUAL",
                    group_background: "DEFAULT",
                  },
                  slots: [
                    {
                      slot_name: "Squad Leader",
                      slot_player: {
                        player_id: "",
                        player_name: "",
                      },
                      slot_shortcode: "SL",
                      slot_gear: "SPAR-16 CARBINE",
                      slot_restricted: true,
                      slot_locked: false,
                      slot_icon_code: "SL",
                      slot_dlc: [],
                      slot_raffle: false,
                      raffle_winner: {
                        player_id: "",
                        player_name: "",
                      },
                      raffle_entrants: [],
                    },
                    {
                      slot_name: "Combat Lifesaver",
                      slot_player: {
                        player_id: "",
                        player_name: "",
                      },
                      slot_shortcode: "CLS",
                      slot_gear: "SPAR-16 CARBINE",
                      slot_restricted: true,
                      slot_locked: false,
                      slot_icon_code: "MED",
                      slot_dlc: [],
                      slot_raffle: false,
                      raffle_winner: {
                        player_id: "",
                        player_name: "",
                      },
                      raffle_entrants: [],
                    },
                  ],
                  child: [
                    {
                      group_data: {
                        group_name: "ALPHA 1",
                        group_orbat_icon: "nato_inf",
                        group_gear: "HMMWV",
                        group_callsign: "FALCON 1",
                        group_background: "DEFAULT",
                      },
                      slots: [
                        {
                          slot_name: "Fireteam Leader",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "FTL",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "SL",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Medium Machinegunner",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "MMG",
                          slot_gear: "SPMG",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "AR",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Assistant Medium Machinegunner",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "AMMG",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "MAN",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Rifleman Antitank",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "RAT",
                          slot_gear: "SPAR-16 CARBINE + AT4",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "AT",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Rifleman",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "R",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "MAN",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                      ],
                      child: [],
                    },
                    {
                      group_data: {
                        group_name: "ALPHA 2",
                        group_orbat_icon: "nato_inf",
                        group_gear: "HMMWV",
                        group_callsign: "FALCON 2",
                        group_background: "DEFAULT",
                      },
                      slots: [
                        {
                          slot_name: "Fireteam Leader",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "FTL",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "SL",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Medium Machinegunner",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "MMG",
                          slot_gear: "SPMG",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "AR",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Assistant Medium Machinegunner",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "AMMG",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "MAN",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Rifleman Antitank",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "RAT",
                          slot_gear: "SPAR-16 CARBINE + AT4",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "AT",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Rifleman",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "R",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "MAN",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                      ],
                      child: [],
                    },
                  ],
                },
                {
                  group_data: {
                    group_name: "BRAVO",
                    group_orbat_icon: "nato_inf",
                    group_gear: "HMMWV",
                    group_callsign: "KESTREL ACTUAL",
                    group_background: "DEFAULT",
                  },
                  slots: [
                    {
                      slot_name: "Squad Leader",
                      slot_player: {
                        player_id: "",
                        player_name: "",
                      },
                      slot_shortcode: "SL",
                      slot_gear: "SPAR-16 CARBINE",
                      slot_restricted: true,
                      slot_locked: false,
                      slot_icon_code: "SL",
                      slot_dlc: [],
                      slot_raffle: false,
                      raffle_winner: {
                        player_id: "",
                        player_name: "",
                      },
                      raffle_entrants: [],
                    },
                    {
                      slot_name: "Combat Lifesaver",
                      slot_player: {
                        player_id: "",
                        player_name: "",
                      },
                      slot_shortcode: "CLS",
                      slot_gear: "SPAR-16 CARBINE",
                      slot_restricted: true,
                      slot_locked: false,
                      slot_icon_code: "MED",
                      slot_dlc: [],
                      slot_raffle: false,
                      raffle_winner: {
                        player_id: "",
                        player_name: "",
                      },
                      raffle_entrants: [],
                    },
                  ],
                  child: [
                    {
                      group_data: {
                        group_name: "BRAVO 1",
                        group_orbat_icon: "nato_inf",
                        group_gear: "HMMWV",
                        group_callsign: "KESTREL 1",
                        group_background: "DEFAULT",
                      },
                      slots: [
                        {
                          slot_name: "Fireteam Leader",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "FTL",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "SL",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Medium Machinegunner",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "MMG",
                          slot_gear: "SPMG",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "AR",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Assistant Medium Machinegunner",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "AMMG",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "MAN",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Rifleman Antitank",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "RAT",
                          slot_gear: "SPAR-16 CARBINE + AT4",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "AT",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Rifleman",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "R",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "MAN",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                      ],
                      child: [],
                    },
                    {
                      group_data: {
                        group_name: "BRAVO 2",
                        group_orbat_icon: "nato_inf",
                        group_gear: "HMMWV",
                        group_callsign: "KESTREL 2",
                        group_background: "DEFAULT",
                      },
                      slots: [
                        {
                          slot_name: "Fireteam Leader",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "FTL",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "SL",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Medium Machinegunner",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "MMG",
                          slot_gear: "SPMG",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "AR",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Assistant Medium Machinegunner",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "AMMG",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "MAN",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Rifleman Antitank",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "RAT",
                          slot_gear: "SPAR-16 CARBINE + AT4",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "AT",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                        {
                          slot_name: "Rifleman",
                          slot_player: {
                            player_id: "",
                            player_name: "",
                          },
                          slot_shortcode: "R",
                          slot_gear: "SPAR-16 CARBINE",
                          slot_restricted: false,
                          slot_locked: false,
                          slot_icon_code: "MAN",
                          slot_dlc: [],
                          slot_raffle: false,
                          raffle_winner: {
                            player_id: "",
                            player_name: "",
                          },
                          raffle_entrants: [],
                        },
                      ],
                      child: [],
                    },
                  ],
                },
                {
                  group_data: {
                    group_name: "WIDOW",
                    group_orbat_icon: "nato_rotary",
                    group_gear: "UH-80 Ghosthawk",
                    group_callsign: "Widow",
                    group_background: "DEFAULT",
                  },
                  slots: [
                    {
                      slot_name: "Pilot",
                      slot_player: {
                        player_id: "",
                        player_name: "",
                      },
                      slot_shortcode: "PILOT",
                      slot_gear: "SPAR-16 CARBINE",
                      slot_restricted: true,
                      slot_locked: false,
                      slot_icon_code: "SL",
                      slot_dlc: [],
                      slot_raffle: false,
                      raffle_winner: {
                        player_id: "",
                        player_name: "",
                      },
                      raffle_entrants: [],
                    },
                    {
                      slot_name: "Co-Pilot",
                      slot_player: {
                        player_id: "",
                        player_name: "",
                      },
                      slot_shortcode: "COPILOT",
                      slot_gear: "SPAR-16 CARBINE",
                      slot_restricted: true,
                      slot_locked: false,
                      slot_icon_code: "SL",
                      slot_dlc: [],
                      slot_raffle: false,
                      raffle_winner: {
                        player_id: "",
                        player_name: "",
                      },
                      raffle_entrants: [],
                    },
                  ],
                  child: [],
                },
              ],
            },
          ],
        },
      ],
    },
  };
};
